'use strict';

function Marketing() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MarketingPresenter, _BranchIO, PartnerAttribution];

  this.init = function () {
    this._super();
    this.checkIncomingParams();
    this.branchIOInit();
  };

  this.initAllReady = function () {
    this._super();
    this.toggleAuthenticatedView();
  };

  this.checkIncomingParams = function () {
    // Mogo referral code:
    // used on signup
    var referrerData = getURLParameter('referral_code').trim();
    if (referrerData) {
      Cookies.set('referredBy', referrerData, { expires: 9999 });
    }

    // Check if it's a Credit Karma deeplink thats being opened in their CK application
    var isVendorApp = getURLParameter('utm_medium').trim();
    if (isVendorApp === 'ck' && this.isIphone()) {
      this.addSpaceToBottom();
    }

    // Moneywise tracking code:
    // used on signup, login, and branch links for app download
    this.saveAttributionData(PartnerAttributionSettings.moneywise.attribution_key);

    // Fintel Connect tracking code:
    // used on signup, login, and branch links for app download
    this.saveAttributionData(PartnerAttributionSettings.fintel_connect.attribution_key);
  };

  /*
    isIphone: checks if user is using iphone
  */
  this.isIphone = function () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    // The !window.MSStream is to not incorrectly detect IE11
    return (/iPhone/.test(userAgent) && !window.MSStream
    );
  };

  // [FYI] Fix for when user views marketing site via an
  // in application browser
  this.addSpaceToBottom = function () {
    // full-anchored-cta is in MogoMini,
    // marketing-signup__fixed-cta in loan preapproval
    // marketing-footer in Footer
    var queryString = '.full-anchored-cta, .marketing-signup__fixed-cta, .marketing-footer-disclaimers';
    var mobileElements = _this.node.querySelectorAll(queryString);
    for (var i = 0; i < mobileElements.length; i++) {
      mobileElements[i].classList.add('open_in_app');
    }
  };

  this.toggleAuthenticatedView = function () {
    var isLoggedIn = window.location.search.indexOf('logged_in') > 0;
    var $loggedInShow = $('.js--logged-in-show');
    var $loggedOutShow = $('.js--logged-out-show');
    var loggedInAnalytics = {
      targetedAudience: 'userIsAlreadyMember',
      event: 'DLevent.targetedAudience'
    };

    if (isLoggedIn) {
      if ($loggedInShow.length) {
        $loggedInShow.removeClass('hide');
      }
      // push analytics if user is logged in and there is authentication logic on the page
      if ($loggedInShow.length || $loggedOutShow.length) {
        dataLayer.push(loggedInAnalytics);
      }
    } else if ($loggedOutShow.length) {
      $loggedOutShow.removeClass('hide');
    }
  };
}